export const mapWithConcurrency = async (items, limit, mapper) => {
    if (!items.length) return [];

    const results = new Array(items.length);
    let nextIndex = 0;

    const workers = Array.from(
        {length: Math.min(Math.max(1, limit), items.length)},
        async () => {
            while (nextIndex < items.length) {
                const index = nextIndex++;
                results[index] = await mapper(items[index], index);
            }
        }
    );

    await Promise.all(workers);
    return results;
};
